import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListItemNode, ListNode } from '@lexical/list';
import { CodeNode } from '@lexical/code';
import { ELEMENT_TRANSFORMERS, TEXT_FORMAT_TRANSFORMERS } from '@lexical/markdown';
import type { InitialConfigType } from '@lexical/react/LexicalComposer';

import { writerLabLexicalTheme } from './lexicalTheme';

/** Node set registered with the Writer's Lab editor. Shared by the live editor
 *  and headless test editors so serialized states round-trip. */
export const WRITER_LAB_NODES = [HeadingNode, QuoteNode, ListNode, ListItemNode, CodeNode];

/**
 * Markdown shortcut transformers. Curated to element + inline-format transformers
 * whose node dependencies are all in WRITER_LAB_NODES — the full `TRANSFORMERS`
 * set includes a LINK transformer that requires LinkNode (not registered in v3.0),
 * which would make MarkdownShortcutPlugin throw. Add LinkNode + the LINK
 * transformer here if/when link markdown shortcuts are wanted.
 */
export const WRITER_LAB_TRANSFORMERS = [...ELEMENT_TRANSFORMERS, ...TEXT_FORMAT_TRANSFORMERS];

/**
 * Build the LexicalComposer initial config. The composer is hoisted to the
 * WriterLab shell (not the canvas) so the rail's operation panels can dispatch
 * commands into the same editor via useLexicalComposerContext.
 *
 * `initialState` is a serialized Lexical EditorState JSON string; omit for an
 * empty document. Read once at mount — switch documents by re-keying the composer.
 */
export function buildInitialConfig(initialState?: string): InitialConfigType {
  return {
    namespace: 'WriterLab',
    theme: writerLabLexicalTheme,
    nodes: WRITER_LAB_NODES,
    editorState: initialState,
    onError: (error: Error) => {
       
      console.error('Lexical error:', error);
    },
  };
}
